// extracted by mini-css-extract-plugin
var _1 = "CommentText_footer__5c669";
var _2 = "CommentText_root__11a19";
var _3 = "CommentText_short__b64f5";
export { _1 as "footer", _2 as "root", _3 as "short" }
